var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-close",
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "svg-icon svg-close color",
    domProps: {
      "innerHTML": _vm._s(_vm.icons.close)
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }